import React, {useContext, useEffect, useState} from 'react';
import {getOrdersWmsStatus} from "../../../../../../api/wms/shipment/shipment";
import {WMSContext} from "../../../../context/WMSContext";
import BeatLoaderRegular from "../../../../../../components/loaders/BeatLoaderRegular";
import {Grid, Paper, Table, TableBody, TableContainer} from "@mui/material";
import DayTracker from "./components/DayTracker";
import Header from "./components/Header";
import {FormattedMessage} from "react-intl";
import {blueColor} from "../../../../../../assets/jss/main";

function OrderTracker() {
    const {currentInventory} = useContext(WMSContext)
    const [loading, setLoading] = useState(true)
    const [orderTracker, setOrderTracker] = useState([])

    const vhToPx = (vh) => {
        return (window.innerHeight * vh) / 100
    }

    useEffect(() => {
        if (currentInventory) {
            getOrdersWmsStatus(currentInventory.id).then((response) => {
                setOrderTracker(response)
            })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [currentInventory]);
    return (
        <Grid container gap={"8px"} sx={{width: '100%', minWidth: 0}}>
            {loading && (
                <BeatLoaderRegular loading={loading}/>
            )}

            <span style={{fontWeight: "bold", color: blueColor}}><FormattedMessage id={"wms.admin.orderTracker.title"} /></span>

            {!loading && orderTracker && (
                <Paper sx={{maxWidth: "100%", width: "100%"}}>
                    <TableContainer sx={{maxHeight: vhToPx(55), overflow: 'overlay'}}>
                        <Table stickyHeader>
                            <Header />
                            <TableBody>
                                {orderTracker.map((dayData) => {
                                    return (
                                        <DayTracker
                                            key={dayData.day}
                                            data={dayData}
                                        />
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
        </Grid>
    );
}

export default OrderTracker;